function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";
import tasks from '@/js/tasks';
import { ROLES_LIST, DATAPLEX_STATES } from '@/js/constants';
import DialogsComponent from "@/components/DialogsComponent.vue";
import bots_services from '@/apps/chatbots/services/bots_services';
import OrganizacionComponent from '@/components/OrganizacionComponent.vue';
import domainService from '@/apps/data-platform/services/master_data/domain_service';
import config_services from "../../services/config_services";
import channels_services from '@/apps/chatbots/services/channels_services';
export default {
  components: {
    DialogsComponent: DialogsComponent,
    OrganizacionComponent: OrganizacionComponent
  },
  data: function data() {
    return {
      nuevoCorreo: "",
      usuarios: [],
      backupUser: {},
      backupGroup: {},
      usuariosToCreate: [],
      usuariosToUpdate: [],
      usuariosToDelete: [],
      activeTab: 0,
      edit: false,
      view: false,
      filters: {},
      show_detail: false,
      filter_enabled: true,
      collapse_filter: false,
      item_selected: {},
      data: [],
      data_to_filter: [],
      list_orgs: [],
      pagination: {
        total: 0,
        limit: 10,
        offset: 1,
        current: 1
      },
      type_embedding_source: [
      //{ value: 'azure', text: 'Azure Embedding'},
      {
        value: 'gemini',
        text: 'Gemini'
      }],
      type_embedding: [
      //{ value: 'text-embedding-3-large', text: 'text-embedding-3-large', source: 'azure'},
      {
        value: 'gemini-embedding-001',
        text: 'gemini-embedding-001',
        source: 'gemini'
      }],
      type_bd_vectorial: [
      //{ value: 'azure', text: 'Azure AI Search'},
      {
        value: 'qdrant',
        text: 'Qdrant'
      }],
      bd_instance: [{
        value: 'qdrant-dev',
        text: "Qdrant DEV",
        source: "qdrant"
      }, {
        value: 'qdrant-prd',
        text: "Qdrant PROD",
        source: "qdrant"
      }, {
        value: 'qdrant-custom',
        text: "Qdrant CUSTOM",
        source: "qdrant"
      }
      //{ value: 'azure-base', text: "AI Search Base", source: "azure"}
      ],
      rules: {
        name: [function (v) {
          return !!v || 'El campo es requerido.';
        }, function (v) {
          return v && v.length <= 100 || 'Menor o igual a 100 caracteres.';
        }],
        otros: [function (v) {
          return !!v || 'El campo es requerido.';
        }, function (v) {
          return v && v.length <= 500 || 'Menor o igual a 500 caracteres.';
        }],
        url: [function (v) {
          return !!v || 'El campo es requerido.';
        }, function (v) {
          return v && v.length <= 1000 || 'Menor o igual a 1000 caracteres.';
        }],
        description: [function (v) {
          return v == "" || v == undefined || v == null || v && v.length <= 1024 || 'Menor o igual a 1024 caracteres.';
        }],
        number: [function (v) {
          return !!v || 'El campo es requerido.';
        }],
        dependent: function dependent(parent) {
          return [function (v) {
            return !parent || !!v || 'El campo es requerido.';
          }];
        }
      },
      chatbots: [],
      playgrounds: [],
      headersUsuarios: [{
        value: "user",
        text: "Usuario"
      }, {
        value: "quota",
        text: "Quota"
      }, {
        value: "actions",
        text: this.traductor('chatbots.bots.metadata.actions')
      }],
      headersGroupUsuarios: [{
        value: "name",
        text: "Grupo"
      }, {
        value: "users",
        text: "Miembros"
      }, {
        value: "quota",
        text: "Quota"
      }, {
        value: "actions",
        text: this.traductor('chatbots.bots.metadata.actions')
      }]
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['projects', 'catalogs', 'orgs', 'isDomainItc'])), {}, {
    getClassTable: function getClassTable() {
      if (this.filter_enabled) {
        return 'col-md-9 col-sm-12';
      } else {
        return 'col-sm-12';
      }
    },
    headers: function headers() {
      return [{
        value: 'domain',
        text: this.traductor('chatbots.domain')
      }, {
        value: 'chatbot',
        text: "Chatbot"
      }, {
        value: 'database_service',
        text: this.traductor('chatbots.data_center.metadata.vector_database')
      }, {
        value: 'tipo_embedding',
        text: this.traductor('chatbots.data_center.metadata.embedding')
      }, {
        value: 'source_embedding',
        text: this.traductor('chatbots.data_center.metadata.embedding_source')
      }, {
        value: 'playground',
        text: "Playground"
      }, {
        value: 'actions',
        text: this.traductor('chatbots.bots.metadata.actions')
      }];
    },
    filteredEmbeddings: function filteredEmbeddings() {
      var _this = this;
      if (!this.item_selected.source_embedding) return [];
      return this.type_embedding.filter(function (e) {
        return e.source === _this.item_selected.source_embedding;
      });
    },
    filteredInstances: function filteredInstances() {
      var _this2 = this;
      if (!this.item_selected.database_service) return [];
      return this.bd_instance.filter(function (e) {
        return e.source === _this2.item_selected.database_service;
      });
    }
  }),
  created: function created() {
    this.listPlayground();
    this.listBots();
    this.getListOrgsDetailed();
    this.getConfigs();
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    getListOrgsDetailed: function getListOrgsDetailed() {
      var _this3 = this;
      domainService.getOrganizationsDetail().then(function (response) {
        if (response.success) {
          _this3.list_orgs = response.data;
        }
      });
    },
    onEnableFilter: function onEnableFilter() {
      this.filter_enabled = !this.filter_enabled;
    },
    onSearch: function onSearch() {
      var _this4 = this;
      this.data = Object.assign([], this.data_to_filter);
      if (this.filters.domain) {
        this.data = this.data.filter(function (x) {
          return x.domain.toUpperCase().indexOf(_this4.filters.domain.toUpperCase()) != -1;
        });
      }
    },
    onLimpiar: function onLimpiar() {
      this.data = Object.assign([], this.data_to_filter);
      this.resetFilters();
    },
    resetFilters: function resetFilters() {
      this.filters = {};
      this.listBots();
      this.getConfigs();
    },
    getConfigs: function getConfigs() {
      var _this5 = this;
      config_services.getAll().then(function (response) {
        console.log(response);
        if (response.success) {
          _this5.data = response.data;
          _this5.data_to_filter = Object.assign([], _this5.data);
          _this5.pagination.total = response.data.length;
        }
      });
    },
    listBots: function listBots() {
      var _this6 = this;
      bots_services.getAll().then(function (response) {
        console.log(response);
        if (response.success) {
          _this6.chatbots = response.data;
        }
      });
    },
    listPlayground: function listPlayground() {
      var _this7 = this;
      channels_services.getAll().then(function (response) {
        console.log(response);
        if (response.success) {
          _this7.playgrounds = response.data.filter(function (x) {
            return x.type == "PLAYGROUND";
          });
        }
      });
    },
    onSaveConfig: function onSaveConfig() {
      var _this8 = this;
      var payload = this.buildPayloadConfig();
      config_services.create(payload).then(function (response) {
        if (response.success) {
          tasks.toast.success("El registro se guardó correctamente.");
          _this8.$refs["DIALOG_CONFIG"].onClose();
          _this8.resetFilters();
        } else {
          tasks.toast.warning("No se pudo guardar el registro.");
        }
      });
    },
    onUpdateConfig: function onUpdateConfig() {
      var _this9 = this;
      var payload = this.buildPayloadConfig();
      config_services.update(payload).then(function (response) {
        if (response.success) {
          tasks.toast.success("El registro se guardó correctamente.");
          _this9.$refs["DIALOG_CONFIG"].onClose();
          _this9.resetFilters();
        } else {
          tasks.toast.warning("No se pudo guardar el registro.");
        }
      });
    },
    goCreatePage: function goCreatePage() {
      this.edit = false;
      this.view = false;
      this.item_selected = {
        groups: []
      };
      this.usuariosToCreate = [], this.usuariosToUpdate = [], this.usuariosToDelete = [], this.$refs["DIALOG_CONFIG"].onOpen();
    },
    onEditProject: function onEditProject(item) {
      this.edit = true;
      this.view = false;
      this.item_selected = _objectSpread(_objectSpread({}, item), {}, {
        groups: (item.groups || []).map(function (g) {
          return _objectSpread(_objectSpread({}, g), {}, {
            edit: false
          });
        })
      });
      this.usuariosToCreate = [], this.usuariosToUpdate = [], this.usuariosToDelete = [], this.loadUsuariosFromConfig(item);
      this.$refs["DIALOG_CONFIG"].onOpen();
    },
    onViewProject: function onViewProject(item) {
      this.edit = false;
      this.view = true;
      this.item_selected = _objectSpread(_objectSpread({}, item), {}, {
        groups: (item.groups || []).map(function (g) {
          return _objectSpread(_objectSpread({}, g), {}, {
            edit: false
          });
        })
      });
      this.usuariosToCreate = [], this.usuariosToUpdate = [], this.usuariosToDelete = [], this.loadUsuariosFromConfig(item);
      this.$refs["DIALOG_CONFIG"].onOpen();
    },
    onRemoveProject: function onRemoveProject(item) {
      this.item_selected = Object.assign({}, item);
      this.$refs["DIALOG_REMOVE_BOT"].onOpen();
    },
    onConfirmRemoveProject: function onConfirmRemoveProject(value) {
      var _this0 = this;
      if (value) {
        bots_services.delete(this.item_selected.id).then(function (response) {
          if (response.success) {
            tasks.toast.success("Se ha eliminado correctamente el registro.");
            _this0.onLimpiar();
            _this0.$refs["DIALOG_REMOVE_BOT"].onClose();
          } else {
            tasks.toast.error("No se ha podido eliminar el registro.");
          }
        });
      } else {
        this.$refs["DIALOG_REMOVE_BOT"].onClose();
      }
    },
    loadUsuariosFromConfig: function loadUsuariosFromConfig(item) {
      this.usuarios = (item.users || []).map(function (u) {
        return _objectSpread(_objectSpread({}, u), {}, {
          edit: false,
          isNew: false
        });
      });
    },
    onAddUser: function onAddUser() {
      var nuevo = {
        id: "temp_" + Date.now(),
        user: "",
        quota: 0,
        edit: true,
        isNew: true
      };
      this.usuarios.push(nuevo);
      this.usuariosToCreate.push(nuevo);
    },
    onEditUser: function onEditUser(item) {
      this.backupUser[item.id] = _objectSpread({}, item);
      item.edit = true;
    },
    onSaveUser: function onSaveUser(item) {
      item.edit = false;
      if (!item.isNew) {
        this.usuariosToUpdate.push(item);
      }
      delete this.backupUser[item.id];
    },
    onCancelEdit: function onCancelEdit(item) {
      if (item.isNew) {
        this.usuarios = this.usuarios.filter(function (u) {
          return u.id !== item.id;
        });
        this.usuariosToCreate = this.usuariosToCreate.filter(function (u) {
          return u.id !== item.id;
        });
      } else if (this.backupUser[item.id]) {
        Object.assign(item, this.backupUser[item.id]);
        delete this.backupUser[item.id];
      }
      item.edit = false;
    },
    onRemoveUser: function onRemoveUser(item) {
      if (item.isNew) {
        this.usuariosToCreate = this.usuariosToCreate.filter(function (u) {
          return u.id !== item.id;
        });
      } else {
        this.usuariosToDelete.push(item);
      }
      this.usuarios = this.usuarios.filter(function (u) {
        return u.id !== item.id;
      });
      delete this.backupUser[item.id];
    },
    // 🔹 Antes de guardar config armamos el payload
    buildPayloadConfig: function buildPayloadConfig() {
      return _objectSpread(_objectSpread({}, this.item_selected), {}, {
        usuarios_to_create: this.usuariosToCreate.map(function (u) {
          return {
            user: u.user,
            quota: u.quota
          };
        }),
        usuarios_to_update: this.usuariosToUpdate.map(function (u) {
          return {
            id: u.id,
            user: u.user,
            quota: u.quota
          };
        }),
        usuarios_to_delete: this.usuariosToDelete.map(function (u) {
          return {
            id: u.id
          };
        }),
        groups: this.item_selected.groups.map(function (g) {
          return {
            id: g.id,
            name: g.name,
            users: g.users,
            quota: g.quota
          };
        })
      });
    },
    onAddGroup: function onAddGroup() {
      var nuevo = {
        id: Date.now(),
        name: "",
        users: [],
        quota: 0,
        edit: true
      };
      this.item_selected.groups.push(nuevo);
    },
    onEditGroup: function onEditGroup(item) {
      this.backupGroup[item.id] = _objectSpread({}, item);
      item.edit = true;
    },
    onSaveGroup: function onSaveGroup(item) {
      item.edit = false;
      delete this.backupGroup[item.id];
    },
    onCancelEditGroup: function onCancelEditGroup(item) {
      if (this.backupGroup[item.id]) {
        Object.assign(item, this.backupGroup[item.id]);
        delete this.backupGroup[item.id];
      }
      item.edit = false;
    },
    onRemoveGroup: function onRemoveGroup(item) {
      this.item_selected.groups = this.item_selected.groups.filter(function (g) {
        return g.id !== item.id;
      });
      delete this.backupGroup[item.id];
    },
    onAddCorreo: function onAddCorreo(item) {
      if (this.nuevoCorreo && !item.users.includes(this.nuevoCorreo)) {
        item.users.push(this.nuevoCorreo);
      }
      this.nuevoCorreo = "";
    },
    onRemoveCorreo: function onRemoveCorreo(item, index) {
      item.users.splice(index, 1);
    }
  }
};